import React from 'react';
import { useWorkerLang } from '../contexts/WorkerLanguageContext';

/**
 * Compact EN | ES pill toggle that reads/writes the WorkerLanguageContext.
 * Use anywhere inside <WorkerLanguageProvider>.
 */
const LANGS = ['en', 'es'];

export default function LangToggle({ size = 'sm' }) {
  const { lang, setLang } = useWorkerLang();
  const h = size === 'sm' ? 'h-7' : 'h-8';
  return (
    <div
      className="inline-flex items-center bg-neutral-100 dark:bg-neutral-800 border-2 border-emerald-500 rounded-lg p-0.5"
      role="group"
      aria-label="Language toggle"
      data-testid="worker-lang-toggle"
    >
      {LANGS.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          className={`px-2 ${h} text-[10px] font-black uppercase tracking-widest rounded transition-all ${lang === code ? 'bg-emerald-500 text-white' : 'text-neutral-500 dark:text-neutral-400 hover:text-neutral-700 dark:hover:text-white'}`}
          data-testid={`worker-lang-${code}-btn`}
          aria-pressed={lang === code}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
